import { createAction } from 'redux-actions';
import { always, compose } from 'ramda';

import {
  APP_STORE_NAVIGATED,
  FEED_PANEL_SELECTED,
} from 'app/features/success/actionTypes';
import { getIsFreeTrialFlow, getParsedSelectedSku } from 'app/router/selectors';
import { SUBSCRIPTION_SKUS_ARRAY } from 'app/constants/freeTrial';
import {
  freeTrialStarted,
  subscriptionStarted,
} from 'app/features/products/actions';
import { fetchWatchlistItems } from 'app/features/watchlist/actions';
import { seriesFetched } from 'app/features/series/actions';
import { lengthOfFreetrial } from 'app/features/products/selectors';

const feedPanelSelected = createAction(FEED_PANEL_SELECTED);
const appStoreNavigated = createAction(APP_STORE_NAVIGATED);

function handleSubscriptionTrackEvents({
  lengthOfFreeTrial: passedLengthOfFT,
} = {}) {
  return (dispatch, getState) => {
    const selectedSku = getParsedSelectedSku(getState());
    const lengthOfFreeTrial = passedLengthOfFT || lengthOfFreetrial(getState());
    const isFreetrialFlow = getIsFreeTrialFlow(getState());

    if (isFreetrialFlow) {
      dispatch(freeTrialStarted({ sku: selectedSku, lengthOfFreeTrial }));
    } else if (SUBSCRIPTION_SKUS_ARRAY.includes(selectedSku)) {
      dispatch(subscriptionStarted({ sku: selectedSku }));
    }
  };
}

function fetchSeriesWithWatchListItems() {
  return (dispatch, _, { api }) =>
    api
      .fetchSeries()
      .then(compose(dispatch, seriesFetched))
      .then(compose(dispatch, fetchWatchlistItems))
      .catch(always([]));
}

export {
  handleSubscriptionTrackEvents,
  feedPanelSelected,
  appStoreNavigated,
  fetchSeriesWithWatchListItems,
};
